import { request } from '@@/plugin-request';

export async function isDstDate(params) {
  return request('/api/users/isDstDate', {
    params,
  });
}
